const ROLE_MAPPING = {
  accountant: 'Бухгалтер',
  estimator: 'Сметчик',
  'project manager': 'Менеджер',
  supplier: 'Поставщик',
  foreman: 'Бригадир',
}

export const USER_ROLES = [
  { id: 3, name: 'Supplier', type: 'supplier' },
  { id: 4, name: 'Foreman', type: 'foreman' },
  { id: 5, name: 'Project manager', type: 'project_manager' },
  { id: 6, name: 'Accountant', type: 'accountant' },
  { id: 7, name: 'Estimator', type: 'estimator' },
]

export const getRoleName = (role) => ROLE_MAPPING[role?.toLowerCase()] || ''

export const ROLE_MAPPING_OPTIONS = Object.entries(ROLE_MAPPING).map(([key, label]) => {
  const value = key.replace(/\s+/g, '_')
  return { value, label }
})

export const viewUserAttrs = (user) =>
  user.data
    ? `${user.data.attributes.second_name} ${user.data.attributes.first_name} (${user.data.attributes.email})`
    : '-'

export const getUserProjects = (user) => user?.projects?.map(({ id }) => id)
